import store from '../store/store'
import axios from 'axios'
import helpers from '@/utils/helpers'

import shopSetting from './shopSetting'

// copy
import clipboard from 'clipboard'

export default {
  mounted() {
    window.addEventListener('DOMContentLoaded', this.device)
  },
  methods: {
    call_api: async (method, url, data, multipart = false) => {
      // 简化URL处理：截取?前面的部分
      const urlBase = url.split('?')[0];
      
      // 定义需要缓存的API路径和对应的缓存键
      const cacheUrls = {
        'setting/header': 'header',
        'setting/footer': 'footer',
        'currency/available': 'available',
        'setting/main': 'main',
        'get-business-settings/show_id_switch': 'show_id_switch',
        'get-business-settings/follow_switch': 'follow_switch',
        // 首页组件相关缓存
        'setting/home/sliders': 'home_sliders',
        'setting/home/popular_categories': 'home_popular_categories',
        'setting/home/banner_section_one': 'home_banner_section_one',
        'setting/home/shop_banner_section_one': 'home_shop_banner_section_one',
        'setting/home/banner_section_two': 'home_banner_section_two',
        'setting/home/shop_banner_section_two': 'home_shop_banner_section_two',
        'setting/home/banner_section_three': 'home_banner_section_three',
        'setting/home/shop_banner_section_three': 'home_shop_banner_section_three',
        'setting/home/banner_section_four': 'home_banner_section_four',
        'setting/home/shop_section_three': 'home_shop_section_three',
        'setting/home/product_section_one': 'home_product_section_one',
        'setting/home/shop_section_two': 'home_shop_section_two',
        'setting/home/product_section_four': 'home_product_section_four',
        'setting/home/product_section_two': 'home_product_section_two',
        'setting/home/shop_section_one': 'home_shop_section_one',
        'setting/home/product_section_three': 'home_product_section_three',
        'setting/home/shop_section_four': 'home_shop_section_four',
        'setting/home/shop_section_five': 'home_shop_section_five',
        'setting/home/product_section_five': 'home_product_section_five',
        'setting/home/product_section_six': 'home_product_section_six',
        // 分类和品牌缓存
        'all-categories': 'all_categories',
        'all-brands': 'all_brands',
        'categories/first-level': 'categories_first_level',
      };
      
      // 检查是否需要缓存此请求
      const cacheKey = Object.keys(cacheUrls).find(key => urlBase.startsWith(key));
      const isCache = cacheKey !== undefined;

      const config = {
        method: method,
        url: store.state.app.apiUrl + store.state.app.apiPath + url,
        data: data
      }
      if (multipart) {
        config.headers = { 'content-type': 'multipart/form-data' }
      }
      try {
        // 获取当前语言
        const currentLanguage = store.getters['app/userLanguage'] || shopSetting.appLanguage
        // 获取缓存语言
        const cacheLang = localStorage.getItem('cache_lang') || shopSetting.appLanguage

        // 语言变更时清除缓存
        if (cacheLang !== currentLanguage) {
          // 清除所有API缓存
          Object.values(cacheUrls).forEach(key => {
            localStorage.removeItem(key)
          })
          // 更新缓存语言
          localStorage.setItem('cache_lang', currentLanguage)
        }

        // 如果是可缓存的请求，且语言匹配，检查缓存
        if (isCache && cacheLang === currentLanguage) {
          const cacheValue = localStorage.getItem(cacheUrls[cacheKey])
          if (cacheValue) {
            const cachedData = JSON.parse(cacheValue)
            
            // 使用setTimeout进行无感请求更新缓存
            setTimeout(() => {
              axios(config)
                .then(response => {
                  localStorage.setItem(cacheUrls[cacheKey], JSON.stringify(response))
                })
                .catch(error => {
                  console.log('缓存更新错误:', error)
                })
            }, 0)
            
            // 立即返回缓存数据
            console.log('使用缓存数据:', cacheKey)
            return cachedData
          }
        }
        
        // 无缓存或缓存失效，发起网络请求
        const res = await axios(config)

        // 如果是可缓存的请求，保存到缓存
        if (isCache) {
          localStorage.setItem(cacheUrls[cacheKey], JSON.stringify(res))
        }

        return res
      } catch (error) {
        console.log('API请求错误:', error)
        return { data: { success: false, message: '请求失败' } }
      }
    },
    static_asset: (path = '') => path,
    snack: (data = {}) => {
      store.commit('snackbar/createSnack', data)
    },
    format_price: (amount = 0) => {
      const currency_setting = store.getters['app/generalSettings'].currency
      const exchange_rate = Number(currency_setting.exchange_rate || 1)
      amount = parseFloat(amount * exchange_rate)
      amount = typeof amount == 'number' ? amount : 0.0

      const current__code = currency_setting.symbol

      let formated_price = amount.toFixed(currency_setting.no_of_decimals)

      if (currency_setting.truncate_price == 1) {
        if (formated_price > 999999.99 && formated_price < 1000000000) {
          formated_price =
            (formated_price / 1000000).toFixed(
              currency_setting.no_of_decimals
            ) + 'M'
        } else if (formated_price > 1000000000) {
          formated_price =
            (formated_price / 1000000000).toFixed(
              currency_setting.no_of_decimals
            ) + 'B'
        }
      }
      formated_price =
        currency_setting.decimal_separator === '1'
          ? formated_price.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          : formated_price
              .replace('.', ',')
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')

      switch (currency_setting.symbol_format) {
        case '2':
          formated_price = formated_price + current__code
          break
        case '3':
          formated_price = current__code + ' ' + formated_price
          break
        case '4':
          formated_price = formated_price + ' ' + current__code
          break
        default:
          formated_price = current__code + formated_price
      }
      return formated_price
    },
    is_addon_activated: (key = '') => {
      const addon = store.getters['app/addons'].find(
        (addon) => addon.unique_identifier === key
      )
      return (
        key && key != '' && typeof addon != 'undefined' && addon.activated == 1
      )
    },
    is_empty_obj: (obj = {}) => {
      return obj && Object.keys(obj).length === 0 && obj.constructor === Object
    },
    discount_percent: (price = 0, discount_price = 0) => {
      price = parseFloat(price)
      discount_price = parseFloat(discount_price)

      return price > discount_price
        ? Math.round((100 * (price - discount_price)) / price)
        : 0
    },
    get_random_color: () => {
      var colors = Array(
        'red',
        'pink',
        'purple',
        'deep-purple',
        'indigo',
        'blue',
        'blue',
        'light-blue',
        'cyan',
        'teal',
        'green',
        'light-green',
        'lime',
        'yellow',
        'amber',
        'orange',
        'deep-orange',
        'brown',
        'blue-grey',
        'grey'
      )
      return colors[Math.floor(Math.random() * colors.length)]
    },
    device() {
      const viewportWidth = window.innerWidth
      if (viewportWidth >= 1904) {
        return 'xl'
      } else if (viewportWidth < 1904 && viewportWidth >= 1264) {
        return 'lg'
      } else if (viewportWidth < 1264 && viewportWidth >= 960) {
        return 'md'
      } else if (viewportWidth < 960 && viewportWidth >= 600) {
        return 'sm'
      } else {
        return 'xs'
      }
    },
    $optional: (p) => eval('this.' + p),
    setSession: (key, status) => {
      const now = new Date()
      const item = {
        status: status,
        expiry: now.getTime() + 3600000
      }

      localStorage.setItem(key, JSON.stringify(item))
    },
    checkSession: (key) => {
      let item = {}
      if (localStorage.getItem(key)) {
        item = localStorage.getItem(key)
        item = JSON.parse(item)
      }
      const now = new Date()

      return typeof item.expiry == 'undefined' || now.getTime() > item.expiry
        ? ''
        : item.status
    },

    copy() {
      const copyCallBack = new clipboard('#copy')

      copyCallBack.on('success', (e) => {
        // 使用e参数
        e && console.log('success');
        this.snack({
          message: this.$t('seller_common_copy_successfully')
        })

        copyCallBack.destroy()
      })

      copyCallBack.on('error', () => {
        this.snack({
          message: this.$t('something_went_wrong')
        })

        copyCallBack.destroy()
      })
    },

    addResourceImage: (src) => {
      if (!src) return helpers.imagePlaceholder()
      const isHttps = src.indexOf('https://') > -1
      const isHttp = src.indexOf('http://') > -1
      const isStatic = src.indexOf('@/assets/') > -1
      const isUpload = src.indexOf('uploads/') > -1 || src.indexOf('assets/') > -1

      if (isHttp || isHttps) {
        return src
      }

      if (isStatic) {
        return src
      }

      return isUpload ? `${shopSetting.imageUrl}${src}` : `${shopSetting.s3Url}${src}`
    }
  }
}
